export const DARK_MODE = "DARK_MODE";

// Theme options for Ant Design
// export const themes = {
//     blue: {
//       '@primary-color': '#1890ff',
//     },
//     green: {
//       '@primary-color': '#52c41a',
//     },
//     red: {
//       '@primary-color': '#ff4d4f',
//     },
//     purple: {
//       '@primary-color': '#722ed1',
//     },
//   };

export const themes = {
  blue: {
    colorPrimary: "#1890ff",
    colorPrimaryHover: "#096dd9",
  },
  green: {
    colorPrimary: "#52c41a",
    colorPrimaryHover: "#389e0d",
  },
  red: {
    colorPrimary: "#ff4d4f",
    colorPrimaryHover: "#d9363e",
  },
  purple: {
    colorPrimary: "#722ed1",
    colorPrimaryHover: "#531dab",
  },
  orange: {
    colorPrimary: "#fa8c16",
    colorPrimaryHover: "#d46b08",
  },
};
